<main class="embed-layout" id="layout" #layout>
  <div class="embed-content" #content>
    <router-outlet />
  </div>
</main>
